import { FETCH_ALL_DOCTOR_DETAILS_BY_IDS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

type DoctorDetailsResponse = {
    success: boolean;
    doctorProfileData: {
        [key: string]: {
            _id: string;
            name: {
                f: string;
                l: string;
            };
            speciality: string;
        };
    };
};

export type DoctorProfileData = {
    [key: string]: {
        _id: string;
        name: {
            f: string;
            l: string;
        };
        speciality: string;
    };
};

export default (doctorIds: string[]): Promise<DoctorDetailsResponse> => {
    return fetchWithRefresh(FETCH_ALL_DOCTOR_DETAILS_BY_IDS, {
        method: 'POST',
        body: JSON.stringify({
            docIds: doctorIds,
        }),
        headers: {
            'Content-Type': 'application/json',
        },
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            throw new Error('Failed to fetch Doctor Details By Ids');
        }
    });
};
